"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAmbientVideoControls = void 0;
var _react = require("react");
var _reactIntersectionObserver = require("react-intersection-observer");
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _zustandBlueprints = require("../../_nextgen/packages/zustand-blueprints");
var _persist = require("../../_nextgen/packages/zustand-blueprints/middleware/persist");
var _usePrefersReducedMotion = require("./usePrefersReducedMotion");
const ambientVideoBlueprint = (0, _zustandBlueprints.createBlueprint)(function (set, get) {
  return {
    autoPlay: true,
    setAutoPlay: function (v) {
      return set({
        autoPlay: v
      });
    }
  };
});
const useAmbientVideoStore = function (_ref) {
  let {
    initialValues
  } = _ref;
  return (0, _zustandBlueprints.useBlueprint)({
    blueprint: [(0, _persist.persistMiddleware)("show-ambient-motion", {
      storage: _persist.sessionStorageAdapter,
      merge: function (persistedState, currentState) {
        // In the case that global settings changed
        if (currentState.prefersReducedMotion !== persistedState.prefersReducedMotion) {
          return currentState;
        }
        return {
          ...currentState,
          ...persistedState
        };
      }
    }), ambientVideoBlueprint],
    initialValues
  });
};
const useAmbientVideoControls = function () {
  const prefersReducedMotion = (0, _usePrefersReducedMotion.usePrefersReducedMotion)(function (prefersReducedMotion) {
    setAutoPlay(!prefersReducedMotion);
  });
  const {
    ref: inViewRef,
    inView
  } = (0, _reactIntersectionObserver.useInView)({
    fallbackInView: true,
    // default to inView === true if observer errors out
    triggerOnce: true
  });
  const {
    autoPlay,
    setAutoPlay
  } = useAmbientVideoStore({
    initialValues: {
      autoPlay: !prefersReducedMotion,
      prefersReducedMotion
    }
  });
  const ref = (0, _react.useRef)();
  const mergedRefs = (0, _reactMergeRefs.default)([ref, inViewRef]);
  (0, _react.useEffect)(function () {
    const video = ref.current;
    if (!video || !inView || !autoPlay && video.currentTime === 0) {
      return;
    }
    const isVideoPlaying = !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
    if (!isVideoPlaying && inView) {
      video.load();
    } else {
      video.pause();
    }
  }, [autoPlay, inView]);
  return {
    ref: mergedRefs,
    autoPlay: autoPlay && inView,
    setAutoPlay,
    prefersReducedMotion
  };
};
exports.useAmbientVideoControls = useAmbientVideoControls;